export default "__VITE_ASSET__DmIWyipw__"